import Language from '@/enums/Language';
import useLanguage from '@/utils/hooks/useLanguage';
import { GlobeEuropeAfricaIcon } from '@heroicons/react/24/outline';
import { Dropdown, Item, Variant } from '../Dropdown';

export default function LanguageSwitch({
	placeholder,
	className,
	variant = 'secondary',
    itemsWrapperClassName,
    selectedClassName,
    selectedNameWrapper,
}: {
	placeholder?: string;
	className?: string;
	variant?: Variant;
    itemsWrapperClassName?: string;
    selectedClassName?: string;
    selectedNameWrapper?: string;
}) {
	const { currentLocale, handleLanguageChange } = useLanguage();

	const langOptions: Item[] = [
		{
			name: 'English',
			value: Language.EN,
		},
		{
			name: 'Nederlands',
			value: Language.NL,
		},
		{
			name: 'Português',
			value: Language.PT,
		},
	];

	return (
		<Dropdown
			data={langOptions}
			selected={currentLocale}
			variant={variant}
			placeholder={placeholder}
			className={className}
            itemsWrapperClassName={itemsWrapperClassName}
            selectedClassName={selectedClassName}
            selectedNameWrapper={selectedNameWrapper}
			data-testid="language-switch-dropdown"
			prependIcon={<GlobeEuropeAfricaIcon />}
			onChange={(item) => handleLanguageChange(item.value as Language)}
		/>
	);
}
